export const FETCH_ROUTES_RESOLVED = "FETCH_ROUTES_RESOLVED";
export const FETCH_ROUTE_LISTS_RESOLVED = "FETCH_ROUTE_LISTS_RESOLVED";